<script setup lang='ts'>
import useSSOLogin from "~/composables/use-sso-login";

const { t } = useI18n();
const route = useRoute();
const appConfig = useRuntimeConfig().public;
const emit = defineEmits(["loginSuccess"]);

const { executeSocialLogin, socialLoginLoading } = useSSOLogin({ onSuccess: onSocialLoginSuccess });
const loginProvider = computed(() => {
  if (appConfig.APP_FLAGS.hasIfaAuth)
    return "ifa";

  return undefined;
});

function onSocialLoginSuccess() {
  emit("loginSuccess");
};
</script>

<template>
  <BaseHeaderAuthButtons :redirect-url="route.fullPath" button-class="h-8 !py-0">
    <template v-if="loginProvider">
      <div class="flex rtl:pr-6 ltr:pl-6">
        <BaseButton
          :name="`sign-in-${loginProvider}`"
          class="w-full text-button-bold lg:w-auto lg:flex-shrink-0 h-10"
          :title="t('labels.sign_in')"
          :disabled="socialLoginLoading"
          @click="executeSocialLogin(loginProvider)"
        >
          {{ t('labels.sign_in') }}
        </BaseButton>
      </div>
    </template>
  </BaseHeaderAuthButtons>
</template>
